import React, { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Briefcase } from "lucide-react";

export default function JobExposureAdmin() {
  const [stats, setStats] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef();

  const load = () => api.get("/admin/job-exposure/stats").then((r) => setStats(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post("/admin/job-exposure/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`Uploaded ${r.data.uploaded} jobs. Data replaced.`);
      load();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Upload failed");
    } finally { setBusy(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  return (
    <div data-testid="job-exposure-admin">
      <div className="card-surface rounded-xl p-6">
        <div className="flex items-center gap-2 mb-2"><Briefcase className="w-5 h-5 text-[#00F0FF]" /><h3 className="font-display font-bold text-lg">AI Job Exposure Data</h3></div>
        <p className="text-sm text-[#94A3B8]">Powers the "How Much Is AI Doing in Your Job?" page. Re-upload a CSV (columns: <span className="font-mono-tech text-[#e2e8f0]">title</span>, <span className="font-mono-tech text-[#e2e8f0]">PCT</span>, optional <span className="font-mono-tech text-[#e2e8f0]">observed_exposure</span>) to replace the dataset with a future release.</p>

        {stats && (
          <div className="mt-4 flex flex-wrap gap-6">
            <div><div className="font-display font-bold text-2xl text-[#00F0FF]" data-testid="job-exposure-total">{stats.total}</div><div className="text-xs text-[#94A3B8] font-mono-tech uppercase">jobs loaded</div></div>
            {stats.top && <div><div className="font-display font-bold text-2xl">{stats.top.pct}%</div><div className="text-xs text-[#94A3B8] font-mono-tech uppercase">highest: {stats.top.title}</div></div>}
          </div>
        )}

        <input ref={fileRef} type="file" accept=".csv" onChange={upload} className="hidden" data-testid="job-exposure-file" />
        <button onClick={() => fileRef.current?.click()} disabled={busy} data-testid="job-exposure-upload-btn"
          className="mt-5 inline-flex items-center gap-2 bg-[#00F0FF] text-[#04121a] font-semibold px-5 py-2.5 rounded-md hover:brightness-110 disabled:opacity-50">
          <Upload className="w-4 h-4" /> {busy ? "Uploading…" : "Re-upload CSV"}
        </button>
        <p className="mt-3 text-xs text-[#64748B]">⚠️ This replaces all existing job exposure data with the uploaded file.</p>
      </div>
    </div>
  );
}
